import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

import { CommonService } from '../../../service/common.service';
import { ToolContainer } from '../../../service/formulas/objects';

@Component({
  selector: 'section-start',
  templateUrl: 'start.html',
  styleUrls: ['start.scss']
})
export class Start {
  private subscription: Subscription;
  public startFields: StartFields;
  public dirty: boolean = false;
  @Output() startClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() resetAll: EventEmitter<any> = new EventEmitter<any>();
  public settingsHolder: ToolContainer;
  constructor(private commonService: CommonService) {
    this.startFields = new StartFields();
  }

  ngAfterViewInit() {
    this.subscription = this.commonService.notifyObservable$.subscribe(res => {
      if (res.option === 'logout') {
        this.subscription.unsubscribe();
      }
      if (
        res.hasOwnProperty('option') &&
        (res.option === 'start' ||
          res.option === 'reset' ||
          res.option === 'resetMaterial' ||
          res.option === 'resetTool')
      ) {
        this.settingsHolder = res.value;
        if (this.settingsHolder.machine) {
          if (this.settingsHolder.machine.spindle && this.settingsHolder.machine.holder) {
            this.settingsHolder.machine.dirty = true;
          }
        }

        this.startFields = {
          tool: this.settingsHolder.tool
            ? '#' +
              this.settingsHolder.tool.itemId +
              ' ' +
              this.settingsHolder.tool.fluteCount +
              ', ' +
              this.settingsHolder.tool.end
            : '',
          material: this.settingsHolder.material
            ? this.settingsHolder.material.name + ' — ' + this.settingsHolder.material.description
            : '',
          operation: this.settingsHolder.currenttoolpath ? this.settingsHolder.currenttoolpath.operationName : '',
          machine:
            this.settingsHolder.machine && this.settingsHolder.machine.dirty
              ? this.settingsHolder.machine.spindle + ', ' + this.settingsHolder.machine.holder
              : ''
        };
      }
    });
  }

  startSetup = (selectedIndex: number) => {
    this.startClicked.emit(selectedIndex);
  };
}

class StartFields {
  public tool: string;
  public material: string;
  public operation: string;
  public machine: string;
  constructor(tool: string = '', material: string = '', operation: string = '', machine: string = '') {
    this.tool = tool;
    this.material = material;
    this.operation = operation;
    this.machine = machine;
  }
}
